import {
  NadajPrzesylkeType,
  ScreenType,
  SposobDoreczeniaType,
  SposobNadaniaType,
} from 'src/app/enums/enums';

export interface NavigationState {
  nadajPrzesylkeTyp: NadajPrzesylkeType;
  sposobNadaniaTyp: SposobNadaniaType;
  sposobDoreczeniaTyp: SposobDoreczeniaType;
  sposobNadaniaStepNumber: number;
  screen: ScreenType;
}

export const initialState: NavigationState = {
  nadajPrzesylkeTyp: NadajPrzesylkeType.POSIADAM_ETYKIETE,
  sposobNadaniaTyp: SposobNadaniaType.NADAJ_W_PUNKCIE,
  sposobDoreczeniaTyp: SposobDoreczeniaType.DORECZENIE_DO_PUNKTU,
  sposobNadaniaStepNumber: 0,
  screen: ScreenType.STRONA_GLOWNA,
};
